import { ISilderName, ItemRoutesProps } from "./PageRoute";
import { Route } from "react-router-dom";
import { findUserPremission } from "../../Pages/Users/Roles/UserSecurityFind";
import { SettingsSections } from "../../Services/SettingService";
import SalesInvoiceTemplate from "../../Template/SalesInvoiceTemplate";
import BankingNestedRoute from "../../Pages/Banking/BankingNestedRoute";
import ResourceNotFound from "../ResourceNotFound";
import { IPermissionActionType } from "../../Pages/Users/Roles/UserPermissionCommonData";
import { ITypeIIsClientSpecificRoleDataType } from "../../../Context/RoleContext";
import DashboardTemplate from "../../Template/DashboardTemplate";
import BankTransactionsTab from "../../Pages/Banking/ImportTransactions/BankTransactionsTab";

const CashAndBankRoute = ({
  currentClient,
  clientSpecificRole,
}: ItemRoutesProps) => {
  return (
    <>
      {/*  ----------- Cash & Bank Route -----------  */}
      <Route
        path={`/${currentClient?.id}/banking/*`}
        element={
          findUserPremission(
            [
              "Voucher.Contra.13.View",
              "Master.Ledger.Bank.View",
              "Master.Ledger.Cash.View",
              "Master.BankReconciliation.View",
              "Master.LoanAccount.View",
              "Master.Cheque.View",
            ],
            clientSpecificRole(),
            currentClient?.id,
            [SettingsSections.Contra],
            {
              actionType: IPermissionActionType.Add,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <SalesInvoiceTemplate
              silderName={ISilderName.Banking}
              element={<BankingNestedRoute />}
              breadcrumprops={[
                {
                  item: "Banking",
                  path: `/books/clients/${currentClient?.id}/banking/bankAccount`,
                },
              ]}
              menuprops={[
                { showData: "Bank Accounts", addButton: "banking/Banks" },
                { showData: "Cash In Hand", addButton: "cashInHand" },
                // { showData: "Cheque", addButton: "cheque" },
                // { showData: "Loan Accounts", addButton: "loanAccounts" },
                {
                  showData: "Bank Reconciliation",
                  addButton: "bank Reconciliation",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />

      <Route
        path={`/${currentClient?.id}/banking/bankTransactionsDetails`}
        element={
          <DashboardTemplate
            element={<BankTransactionsTab />}
            breadcrumprops={[
              {
                item: "Banking",
                path: `/books/clients/${currentClient?.id}/banking/bankAccounts`,
              },
              {
                item: "BankTransactionsDetails",
              },
            ]}
          />
        }
      />

      <Route
        path={`/${currentClient?.id}/banking/bankTransactionsHistory`}
        element={
          <DashboardTemplate
            element={<BankTransactionsTab />}
            breadcrumprops={[
              {
                item: "Banking",
                path: `/books/clients/${currentClient?.id}/banking/bankAccounts`,
              },
              {
                item: "BankTransactionsHistory",
              },
            ]}
          />
        }
      />

      <Route
        path={`/${currentClient?.id}/banking/bankTransactionsDetails/:id`}
        element={
          <DashboardTemplate
            element={<BankTransactionsTab />}
            breadcrumprops={[
              {
                item: "Banking",
                path: `/books/clients/${currentClient?.id}/banking/bankAccounts`,
              },
              {
                item: "BankTransactionsDetails",
              },
            ]}
          />
        }
      />
    </>
  );
};

export default CashAndBankRoute;
